<template>
  <div class="loc-prod-detail-add-stash-wrapper">
     <add-to-stash-main 
        :productvariants="productvariants"
        :outofStockSubscribeVariants="outofStockSubscribeVariants"
        :product="productdetail" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import AddToStashMain from '@/Components/Pages/PageComponents/LocationProductDetailNew/AddToStashMain';

export default {
  name: 'LocationProductAddToStashDesktop',
  components: {
    AddToStashMain,
  },
  data() {
    return {
    };
  },
  
  props:{
    productdetail: {
      required: true,
      type: Object,
    },
    outofStockSubscribeVariants: {
      required: true,
      type: Array,
    },
    productvariants: {
      required: true,
      type: Array,
    },
  },

};
</script>
